class ThemeSliderComponent extends HTMLElement {
  constructor() {
    super();
    this.swiperInstance = null;
  }

  connectedCallback() {
    if (this.swiperInstance) return;

    this.swiperWrapper = this.querySelector('.swiper-wrapper');
    this.swiperSlides = this.querySelectorAll('.swiper-slide');
    this.swiperPagination = this.querySelector('.swiper-pagination');
    this.swiperScrollbar = this.querySelector('.swiper-scrollbar');

    const slidesPerView = this.dataset.slidesPerView ?? this.getAttribute('slides-per-view') ?? '1';
    const spaceBetween = this.dataset.spaceBetween ?? this.getAttribute('space-between') ?? '10';
    const slidesPerViewMobile = this.dataset.slidesPerViewMobile ?? this.getAttribute('slides-per-view-mobile') ?? '1';
    const spaceBetweenMobile = this.dataset.spaceBetweenMobile ?? this.getAttribute('space-between-mobile');
    const slideToActiveSlide = (this.dataset.slideToActiveSlide ?? this.getAttribute('slide-to-active-slide')) === 'true';

    this.initSwiper(slidesPerView, slidesPerViewMobile, spaceBetween, spaceBetweenMobile, slideToActiveSlide);
  }

  initSwiper(slidesPerView, slidesPerViewMobile, spaceBetween, spaceBetweenMobile, autoSlide) {
    if (typeof Swiper === 'undefined') {
      console.warn('ThemeSliderComponent: Swiper is not loaded');
      return;
    }
    if (!this.swiperWrapper || this.swiperSlides.length === 0) {
      return;
    }

    const numericOrAuto = (value) => {
      if (value === 'auto') return 'auto';
      const n = Number(value);
      return Number.isNaN(n) ? 1 : n;
    };

    const config = {
      slidesPerView: numericOrAuto(slidesPerViewMobile),
      spaceBetween: Number(spaceBetweenMobile) || Number(spaceBetween),
      breakpoints: {
        749: {
          spaceBetween:  Number(spaceBetween),
          slidesPerView: numericOrAuto(slidesPerView)
        }
      }
    };

    if (autoSlide === true) {
      const activeSlide = this.querySelector('.swiper-slide.is-active');
      const activeIndex = activeSlide ? Array.from(this.swiperSlides).indexOf(activeSlide) : -1;
      if (activeIndex >= 0) {
        config.initialSlide = activeIndex;
      }
    }

    if (this.swiperPagination) {
      config.pagination = { el: this.swiperPagination, clickable: true };
    }

    if (this.swiperScrollbar) {
      config.scrollbar = { el: this.swiperScrollbar, draggable: true };
    }

    const autoplayDelay = parseInt(this.dataset.autoplay || '0', 10);
    if (autoplayDelay > 0) {
      config.autoplay = {
        delay: autoplayDelay,
        disableOnInteraction: false,
        pauseOnMouseEnter: true
      };
    }

    const sectionRoot = this.closest('.shopify-section');
    const prevEl = this.querySelector('.swiper-button-prev') || sectionRoot?.querySelector('.swiper-button-prev');
    const nextEl = this.querySelector('.swiper-button-next') || sectionRoot?.querySelector('.swiper-button-next');
    if (prevEl && nextEl) {
      config.navigation = { prevEl, nextEl };
    }

    this.swiperInstance = new Swiper(this, config);
  }
}

if (!customElements.get('theme-slider')) {
  customElements.define('theme-slider', ThemeSliderComponent);
}
